import { Component, OnInit } from "@angular/core";
import { AuthService } from "./shared/auth.service";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  InteractionStatus,
} from "@azure/msal-browser";
import { MsalBroadcastService, MsalService } from "@azure/msal-angular";
import { error } from "console";
import { ConfigsLoaderService } from "./shared/configs-loader.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  public currentUserData: any;
  public CurrentUser: any;
  public isIframe = false;
  public loginDisplay = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private broadcastService: MsalBroadcastService,
    private authService: AuthService,
    private msalService: MsalService,
    private configLoaderService: ConfigsLoaderService
  ) {}

  public ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

    this.msalService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (
          !this.msalService.instance.getActiveAccount() &&
          this.msalService.instance.getAllAccounts().length > 0
        ) {
          this.msalService.instance.setActiveAccount(result.account);
        }
      },
      error: (error) => console.log(error),
    });

    this.broadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) =>
            msg.eventType === EventType.LOGIN_SUCCESS ||
            msg.eventType === EventType.SSO_SILENT_SUCCESS
        )
      )
      .subscribe(
        (result: EventMessage) => {
          const payload = result.payload as AuthenticationResult;
          this.msalService.instance.setActiveAccount(payload.account);
        },
        (error) => console.log(error)
      );

    this.broadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(async () => {
        if (!this.authenticated) {
          await this.logIn();
        }
      },(error) => console.log(error));
  }
  setLoginDisplay() {
    this.loginDisplay = this.msalService.instance.getAllAccounts().length > 0;
  }

  async logIn() {
    await this.msalService.instance.loginRedirect({
      scopes: ["user.read", "openid", "profile"],
      redirectUri: this.configLoaderService.AZURE_AD_REDIRECTURI,
    });
  }

  get authenticated(): boolean {
    return this.msalService.instance.getActiveAccount() ? true : false;
  }
}
